// extracted by css-extract-rspack-plugin
var _1 = "e1ixOobXKjx5gkm9hzU3YQ--";
var _2 = "tfSVfxJ-D8w0y7HwxuC2PQ--";
var _3 = "Apilq1lSYruZGwoYdOREsQ--";
export { _1 as "iconButton", _2 as "sizeNormal", _3 as "sizeSmall" }
